module.exports = __webpack_public_path__ + "static/media/galdisa_servicios_ciclo_cultivo_1.ff46050a.jpg";